<template>
  <v-container
    class="benefits-section-wrapper"
    fluid
    :style="{
      'background-color': data.color,
    }"
  >
    <v-row>
      <v-col class="col-12 col-md-10 pa-md-0 wrap" offset-md="1">
        <h2 v-html="data.title"></h2>
        <ul class="benefits-list-wrapper row">
          <li
            v-for="(benefit, i) in data.benefitsList"
            :key="i"
            class="col col-12 col-md-4 pa-0"
          >
            <div class="content">
              <v-img
                contain
                :src="require('@/assets/images/homepage/' + benefit.icon)"
              />
              <h3 v-html="benefit.title"></h3>
              <p v-html="benefit.text"></p>
            </div>
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'BenefitsSection',
  components: {},
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  beforeMount() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.benefits-section-wrapper
  padding-top: 185px
  padding-bottom: 50px
  h2
    display: inline-block
    font-family: 'metropolissemi_bold'
    font-weight: 600
    font-size: 32px
    line-height: 1.8
    color: #003036
    border-bottom: 4px solid #26D07C
    text-shadow: 0.5px 0.5px #003036
    margin-bottom: 35px
  .benefits-list-wrapper
    padding: 0
    margin: 0
    list-style-type: none
    li
      margin-bottom: 15px
      .content
        background: #FFFFFF
        position: relative
        display: block
        min-height: 350px
        margin-right: 15px
        padding: 48px 24px 0
        border: 1px solid #DEF7E5
        border-radius: 8px 8px 0px 0px
        &:hover
          &:after,
          .v-image
            background: #26D07C
            transition: all 400ms ease-in-out
          h3
            color: #26D07C
            transition: all 400ms ease-in-out
        &:after
          background: #003036
          content: ''
          position: absolute
          display: block
          width: 100%
          height: 8px
          bottom: 0
          left: 0
          border-radius: 16px 16px 0px 0px
          transition: all 400ms ease-in-out
        .v-image
          background: #003036
          width: 80px
          margin-bottom: 30px
          border-radius: 50%
          transition: all 400ms ease-in-out
          ::v-deep
            .v-image__image
              background-size: 50px
        h3
          font-family: 'metropolisbold'
          font-style: normal
          font-weight: 700
          font-size: 18px
          line-height: 1
          text-transform: uppercase
          color: #003036
          margin-bottom: 30px
          transition: all 400ms ease-in-out
          ::v-deep
            span
              font-family: 'metropolisregular'
              font-weight: 400
        p
          font-family: 'metropolisregular'
          font-style: normal
          font-weight: 400
          font-size: 18px
          line-height: 1.4
          color: #003036
          ::v-deep
            span
              font-family: 'metropolisbold'
              font-style: normal
              font-weight: 700
  @media screen and (max-width: 959px)
    padding-top: 50px
    padding-bottom: 50px
    .wrap
      display: flex
      flex-flow: column
      align-items: center
    .benefits-list-wrapper
      li
        .content
          margin-right: 0
</style>
